export class CpcOrganizationunitModel {
    ouId: string;
    ouShortName: string;
    ouLongName: string;
}